import React from "react";
import { stepStyles } from "../formStyles";

export const Buy = ({ formData, setForm, navigation }) => {
  const { firstName, lastName } = formData;

  return (
    <div className={stepStyles.page}>
      <div className={stepStyles.content}>
        <div className={stepStyles.panel}>
          <h1 className={stepStyles.title}>Buy flow placeholder</h1>
          <p className="mt-4 text-lg font-medium text-gray-satan">
            This legacy screen now follows the Warp Speed system if it is ever reached.
          </p>
          <div className={stepStyles.fieldStack}>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="firstName"
                  value={firstName}
                  onChange={setForm}
                  id="firstName"
                  className={stepStyles.input}
                  placeholder="First Name"
                />
              </div>
              <label htmlFor="firstName" className={stepStyles.fieldLabel}>
                First Name
              </label>
            </div>
            <div className={stepStyles.fieldRow}>
              <div className="w-full md:w-auto">
                <input
                  name="lastName"
                  value={lastName}
                  onChange={setForm}
                  id="lastName"
                  className={stepStyles.input}
                  placeholder="Last Name"
                />
              </div>
              <label htmlFor="lastName" className={stepStyles.fieldLabel}>
                Last Name
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <button className={`${stepStyles.button} w-full md:w-auto`} onClick={() => navigation.next()}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
